import AixueFooter from '@/components/AixueFooter/index';
import Screen1 from './screen1';
import Screen2 from './screen2';
import Screen3 from './screen3';
import Screen4 from './screen4';
import styles from './index.module.scss';

export default function AixuePhonics() {
  return (
    <div className={styles.container} data-scroll-root="aixue-phonics">
      <Screen1 />
      <Screen2 />
      <Screen3 />
      <Screen4 />
      <AixueFooter />
    </div>
  );
}
